import { getAttorneySurfaceConfig } from "../../../features/bonds/shared/attorneyInformationConfig";

const retrievalSurface = getAttorneySurfaceConfig("retrieval");

/** Bond retrieval attorney step — per bond type (Phase 14 / 9.10B). */
export const RETRIEVAL_ATTORNEY_CONFIG = {
  probate: {
    ...retrievalSurface,
    attorneyInvolvedDefault: "Yes",
    showAttorneyInvolvedToggle: false,
  },
  va: {
    ...retrievalSurface,
    attorneyInvolvedDefault: "Yes",
    showAttorneyInvolvedToggle: true,
  },
  trustee: {
    ...retrievalSurface,
    attorneyInvolvedDefault: "Yes",
    showAttorneyInvolvedToggle: true,
  },
  guardianship: {
    ...retrievalSurface,
    attorneyInvolvedDefault: "Yes",
    showAttorneyInvolvedToggle: true,
  },
};
